import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";
import { DocumentReference } from "@angular/fire/compat/firestore";
import { PublishStatusEnum } from "../enums/publishStatus.enum";

export class AssignedCategory extends FBase {

    name: string = null;
    nameLowercase: string = null;
	category: DocumentReference = null;
    formLink: string = null;
    requireFormFirst: boolean = false;
    instructor: string = null;
    image: string = null;
    userId: string = null;
    status: PublishStatusEnum = null;

    __modified: boolean = false;

    constructor(json?: { [key: string]: any }) {
        super();
        if (isObject(json)) {
            this.fromJson(json);
        }
    }
}
export namespace AssignedCategory {
    export const PATH = 'assignedCategories';
}
